import classnames from 'classnames'

const cn = classnames

export default cn
